import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspection extends BaseModelAPI {
	static entity = 'finishgoodqualityinspection';
	static entityName = 'finishgoodqualityinspection';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.controlCardId = '';
		this.controlCard = {};
		this.qtyBefore = 0;
		this.qtyAfter = 0;
		this.qtyPending = 0;
		this.qtyNg = 0;
		this.metodeQcId = '';
		this.metodeQc = {};
		this.partId = '';
		this.part = {};
		this.workOrderProcessDetailId = '';
		this.workOrderProcessDetail = {};
		this.finishGoodQualityInspectionNg = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async scanControlCard(this_, id, qrCode) {
		return this_.$http.get(`${this.entityName}/scancontrolcard/${id}?qrcode=` + qrCode)
			.then(function (response) {
				if (response != null) {
					return response.data;
				}
				// this_.toast({ message: '', title: 'Error', variant: 'danger' });
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Scan Control Card!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}

	static async finishScan(this_, id) {
		return this_.$http.put(`${this.entityName}/finishscan/${id}`)
			.then(function (response) {
				if (response != null) {
					return response.data;
				}
				// this_.toast({ message: '', title: 'Error', variant: 'danger' });
			})
			.catch(function (error) {
				var stringError = 'Gagal Menyelesaikan finish good!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}

	static async printPcc(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		let _this = this_;
		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printpcc/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Print PCC!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
				throw error;
			});
	}

}